import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export type OrganizationUpdate = {
  companyName: string;
  companyUrl: string;
};

export const useUpdateOrganisation = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: OrganizationUpdate) =>
      apiClient.onboarding.submitOrganizationData({
        requestBody: {
          name: requestBody.companyName,
          website: requestBody.companyUrl === "" ? null : requestBody.companyUrl,
        },
      }),
  });

  const { mutate, ...mutationResult } = mutation;

  return {
    ...mutationResult,
    updateOrganisation: mutate,
  };
};
